import NextLink from "next/link"
import { Link, SystemStyleObject } from "@chakra-ui/react"

const logoStyles = {
  display: "block",
  position: "relative",
  width: ["100px", "110px", "120px"],
  pt: "29.72%",
  cursor: "pointer",
  svg: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    g: {
      transition: "fill 0.15s ease-out",
    },
  },
  _hover: {
    svg: { g: { fill: "white", transition: "fill 0.15s ease-out" } },
  },
}

const Logo = ({ sx }: { sx?: SystemStyleObject }): JSX.Element => {
  return (
    <NextLink href="/" passHref>
      <Link as="a" sx={{ ...logoStyles, ...sx }}>
        <svg
          width="740"
          height="220"
          viewBox="0 0 740 220"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="#FF443F" fillRule="evenodd">
            <path d="M45.455 35.834c7.881 0 9.078 4.776 9.078 21.019v23.169h35.83v-25.56C90.362 16.007 74.36 0 45.454 0S.548 16.007.548 54.462v43.476h35.83V56.853c0-16.243 1.192-21.02 9.077-21.02M157.315 2.39v77.63h-22.453V2.39h-35.83v95.548h94.112V2.39zM237.643 80.021V38.22h32.246V2.39h-68.075v95.548h68.075V80.021zM314.388 80.023V38.22h32.246V2.39H278.56v95.548h68.075V80.023zM406.952 79.307c-13.375-10.271-19.586-15.766-19.586-29.62 0-9.077 1.913-13.853 7.409-13.853 5.49 0 8.358 4.776 8.358 23.41h35.828C438.961 18.391 424.871 0 394.774 0c-30.101 0-43.236 18.392-43.236 49.688 0 24.718 8.64 37.878 19.688 48.25h56.234c-5.601-6.895-12.598-12.606-20.507-18.631M450.017 97.938h35.829V2.39h-35.829zM525.116 97.938h35.829V2.39h-35.829zM603.05 2.39h-35.83l11.706 95.548h31.727zM627.174 2.39l-7.452 95.548h31.581L663.008 2.39zM736.109 80.021h-32.246V38.22h32.246V2.39h-68.075v95.548h68.075zM2.52 167.093c1.345 38.433 17.897 53.87 46.784 52.86 28.887-1.01 44.32-17.566 42.976-55.999l-.893-25.543-35.807 1.253.809 23.154c.568 16.233-.462 21.048-8.337 21.324-7.881.275-9.24-4.456-9.807-20.69l-1.436-41.06L1 123.645l1.52 43.448zM102.764 215.693l35.807-1.252-2.713-77.584 22.44-.785 2.713 77.584 35.807-1.252-3.339-95.49-94.054 3.289zM205.483 212.1l68.034-2.379-1.252-35.807-32.227 1.128-1.46-41.778 32.226-1.126-.627-17.907-68.033 2.38zM282.182 209.418l35.807-1.251-2.714-77.586 32.228-1.128-.627-17.904-68.034 2.38zM388.051 123.496c16.207 12.339 18.796 17.983 19.28 31.833.401 11.457-.866 16.279-7.549 16.513-6.684.234-10.195-4.422-11.18-32.59l-35.807 1.252c1.928 55.144 16.964 68.243 48.24 67.15 31.27-1.094 43.28-19.918 42.103-53.577-.763-21.84-6.512-35.063-15.486-45.352l-56.2 1.965c5.237 4.584 10.96 8.564 16.6 12.806M453.535 203.426l68.034-2.379-1.253-35.807-32.226 1.127-2.087-59.683-35.807 1.252zM528.588 200.802l35.807-1.253-3.339-95.49-35.807 1.253zM617.322 159.693l-6.589-57.37-31.708 1.109 15.037 95.08L643 196.8l8.358-95.9-31.561 1.105zM736.738 115.844l-.626-17.906-68.033 2.38 3.34 95.489 68.032-2.38-1.252-35.806-32.225 1.127-1.462-41.777z" />
          </g>
        </svg>
      </Link>
    </NextLink>
  )
}

export default Logo
